<template>
    <section class="step-section">
        <header class="step-header">
            <h2 class="step-header__title">
                {{ steps[currentStep] }}
            </h2>
            <IconLoading v-if="!existingTrip" style="margin-left: 20px;" />
        </header>

        <VeeForm v-slot="{ handleSubmit, errors }" :validation-schema="schema" as="div" v-if="existingTrip">
            <form @submit="handleSubmit($event, onSubmit)">
                <div class="step-form__row">
                    <div class="step-form__col">
                        <label for="broker_name" class="label">{{ __("json.Consignee") }} <span class="red-color">*</span></label>
                        <div class="input-group" :class="{ 'has-error': errors.broker_name }">
                            <Field v-model="form.broker_name" type="text" name="broker_name" v-slot="{field}">
                                <textarea v-bind="field" rows="4" class="input" id="broker_name" :placeholder="__('json.Consignee')" style="height: 100px">
                                </textarea>
                            </Field>
                            <div class="input-group__error">
                                <ErrorMessage name="broker_name" />
                            </div>
                        </div>
                    </div>
                    <div class="step-form__col">
                        <label for="consignee_address" class="label">{{ __("json.Address") }} <span class="red-color">*</span></label>
                        <div class="input-group" :class="{ 'has-error': errors.consignee_address }">
                            <Field v-model="form.consignee_address" type="text" name="consignee_address" v-slot="{field}">
                                <textarea v-bind="field" rows="4" class="input" id="consignee_address" :placeholder="__('json.Address')" style="height: 100px">
                                </textarea>
                            </Field>
                            <div class="input-group__error">
                                <ErrorMessage name="consignee_address" />
                            </div>
                        </div>
                    </div>
                    <div class="step-form__col">
                        <label for="broker_phone" class="label">{{ __("json.Phone Number") }} <span class="red-color">*</span></label>
                        <div class="input-group" :class="{ 'has-error': errors.broker_phone }">
                            <Field v-model="form.broker_phone" name="broker_phone" v-slot="{field}">
                                <div class="input" style="padding: 0 !important;">
                                    <vue-tel-input
                                        class="vti-uruk-input"
                                        v-model="form.broker_phone"
                                        default-country="iq"
                                        :ignored-countries="['il', 'as', 'ag', 'ai', 'bs', 'bm', 'vg', 'ky', 'dm', 'gd', 'gu', 'tc', 'vi', 'tt', 'lc', 'vc', 'kn', 'mp', 'jm', 'ms', 'sx']"
                                        :inputOptions="phoneInputOptions" />
                                </div>
                            </Field>
                            <div class="input-group__error">
                                <ErrorMessage name="broker_phone" />
                            </div>
                        </div>
                    </div>
                    <div class="step-form__col">
                        <label for="real_broker_name" class="label">{{ __("json.Broker Name") }} <span class="red-color">*</span></label>
                        <div class="input-group" :class="{ 'has-error': errors.real_broker_name }">
                            <Field v-model="form.real_broker_name" type="text" name="real_broker_name" v-slot="{field}">
                                <textarea v-bind="field" rows="4" class="input" id="real_broker_name" :placeholder="__('json.Broker Name')" style="height: 100px">
                                </textarea>
                            </Field>
                            <div class="input-group__error">
                                <ErrorMessage name="real_broker_name" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="step-form__col">
                        <label for="broker_passport_id" class="label">{{ __("json.Passport No.") }} <span class="red-color">*</span></label>
                        <div class="input-group" :class="{ 'has-error': errors.broker_passport_id }">
                            <Field v-model="form.broker_passport_id" type="text" name="broker_passport_id" v-slot="{field}">
                                <input v-bind="field" class="input" id="broker_passport_id" :placeholder="__('json.Passport No.')">
                            </Field>
                            <div class="input-group__error">
                                <ErrorMessage name="broker_passport_id" />
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="step-form__col">
                        <label for="broker_email" class="label">{{ __("main.email") }}</label>
                        <div class="input-group" :class="{ 'has-error': errors.broker_email }">
                            <Field v-model="form.broker_email" type="email" name="broker_email" v-slot="{field}">
                                <input v-bind="field" class="input" id="broker_email" :placeholder="__('main.email')">
                            </Field>
                            <div class="input-group__error">
                                <ErrorMessage name="broker_email" />
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="step-form__buttons">
                    <button class="button button--outline step-form__button" type="button" @click="handlePrev">
                        {{ __("json.Previous step") }}
                    </button>
                    <button class="button button--blue step-form__button" type="submit">
                        {{ __("json.Next step") }}
                    </button>
                </div>
            </form>
        </VeeForm>
    </section>
</template>

<script>
import {ErrorMessage, Field, Form as VeeForm} from 'vee-validate';
import {VueTelInput} from "vue-tel-input";
import * as yup from 'yup';
import lang from "../../app/lang";
import IconLoading from "../partials/IconLoading.vue";
import {useGetExistingTrip} from "../utils/useGetExistingTrip";

let phoneValidationsCount = 0;

const schema = yup.object({
    broker_name: yup.string()
        .required(lang('validation.required', { 'attribute': lang('json.Consignee') }))
        .matches(/^([^0-9]*)$/, lang('validation.alpha', {'attribute': lang('json.Consignee')}))
        .nullable(),
    consignee_address: yup.string()
        .required(lang('validation.required', { 'attribute': lang('json.Address') }))
        .nullable(),
    real_broker_name: yup.string()
        .required(lang('validation.required', { 'attribute': lang('json.Broker Name') }))
        .nullable(),
    // broker_passport_id: yup.string()
    //     .required(lang('validation.required', { 'attribute': lang('json.Passport No.') }))
    //     .nullable(),
    // broker_email: yup.string()
    //     .email(lang('validation.email', { 'attribute': lang('main.email') }))
    //     .nullable(),
    broker_phone: yup.string()
        .required(lang('validation.required', { 'attribute': lang('json.Phone Number') }))
        .test({
            name: 'phone-regex',
            message: lang('validation.regex', {'attribute': lang('json.Phone Number')}),
            test: (phone) => {
                phoneValidationsCount += 1;
                if (phoneValidationsCount > 2 && phone?.length) {
                    let re = new RegExp(/^([+]|[00]{2})([0-9]{9,})+$/g);
                    return re.test(phone);
                }

                return true;
            }
        })
        .nullable(),
});

export default {
    name: "Step3",
    props: {
        modelValue: {
            type: Number,
            required: true
        },
        steps: {
            type: Object,
            required: true
        },
        tripType: {
            type: String,
            required: true
        },
        action: {
            type: String,
            required: true
        },
        updateTripId: {
            type: Number,
            required: false
        },
    },
    components: {
        VeeForm,
        Field,
        ErrorMessage,
        VueTelInput,
        IconLoading,
    },
    setup() {
        const { getExistingTrip, existingTrip } = useGetExistingTrip();
        return {
            getExistingTrip, existingTrip
        }
    },
    data() {
        return {
            currentStep: this.modelValue,
            form: {
                broker_name: null,
                broker_phone: null,
                broker_email: null,
                broker_passport_id: null,
                consignee_address: null,
                real_broker_name: null
            },
            schema,
            phoneInputOptions: {
                autoFormat: true,
                mode: 'international',
                validCharactersOnly: true,
                showDialCode: true,
                placeholder: '+12 000 000 00 00', // this.$root.__("main.phone"),
            },
        }
    },
    mounted() {
        this.getExistingTrip(this.tripType, this.updateTripId).then((data) => {
            if (Object.keys(data).length !== 0) {
                this.updateFormData();
            }
        })
    },
    computed: {
        formWithTripType() {
            if (!('tripType' in this.form)) {
                Object.assign(this.form, { 'tripType': this.tripType })
            }
            return this.form;
        },
    },
    emits: ['update:modelValue'],
    methods: {
        async fillStep() {
            let url = "/reservation/fill-step";
            if (this.action === "update") {
                url += "/" + this.existingTrip.id;
            }
            await axios.post(url, this.formWithTripType);
        },
        onSubmit() {
            this.fillStep();
            const _currentStep = this.modelValue + 1;
            this.$emit('update:modelValue', _currentStep);
        },
        handlePrev() {
            const _currentStep = this.modelValue - 1;
            this.$emit('update:modelValue', _currentStep);
        },
        updateFormData() {
            this.form.broker_name = this.existingTrip ? this.existingTrip.broker_name : null;
            this.form.broker_email = this.existingTrip ? this.existingTrip.broker_email : null;
            this.form.broker_passport_id = this.existingTrip ? this.existingTrip.broker_passport_id : null;
            this.form.consignee_address = this.existingTrip ? this.existingTrip.consignee_address : null;
            this.form.real_broker_name = this.existingTrip ? this.existingTrip.real_broker_name : null;
            if (this.existingTrip && this.existingTrip.broker_phone) {
                this.form.broker_phone = this.existingTrip.broker_phone;
            }
        },
    },
    watch: {
        'form.broker_phone'() {
            this.form.broker_phone = this.form.broker_phone.replace(' ', '');
        }
    },
}
</script>
